import React from "react";
import Banner from "../components/Banner";
import Features from "../components/Features";

const Main = () => {
  return (
    <>
      <Banner />
      <Features />
    </>
  );
};

export default Main;
